const map = new WeakMap<object, number>();
let current = 0;

export function objectId(x: object) {
  if (!map.has(x)) {
    map.set(x, ++current);
  }
  return map.get(x);
}
